// extracted by mini-css-extract-plugin
export default {"l_PaymentHistory_main":"PaymentHistory_l_PaymentHistory_main__61MC9"};